import Vue from 'vue';
import { createPinia, PiniaVuePlugin, setActivePinia } from 'pinia';

// Ensure Vue is available globally for vue-demi
if (typeof window !== 'undefined') {
  (window as any).Vue = Vue;
}

// Install Pinia plugin for Vue 2.7
Vue.use(PiniaVuePlugin);

// Create and export pinia instance
export const pinia = createPinia();

// Set the active Pinia instance globally
setActivePinia(pinia);
